import React from 'react';
import { EditModifierState } from './editModifierState/EditModifierState';
import { Forms } from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows';

export const EditModifierPageV2: React.FC = () => {
	return (
		<EditModifierState>
			<Forms />
			<ModalWindows />
		</EditModifierState>
	);
};
